import { HttpErrorParser } from "@/App/services/HttpErrorParser";
import { AxiosError } from "axios";

export const handleHttpRequest = async <T>(action: Promise<T>): Promise<T> => {
  try {
    return await action;
  } catch (error) {
    throw HttpErrorParser.parse(error as AxiosError);
  }
};
